import { useState } from 'react';

const DIAS = ['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo'];
const HORAS_APERTURA  = ['06:00','07:00','08:00','09:00','10:00'];
const HORAS_CIERRE    = ['20:00','21:00','22:00','23:00','00:00'];

export default function StepHorarios({ datos, onNext, onBack, cargando }) {
  const [diasActivos, setDiasActivos] = useState(
    datos.diasActivos || ['Sábado','Domingo']
  );
  const [apertura, setApertura] = useState(datos.apertura || '08:00');
  const [cierre,   setCierre]   = useState(datos.cierre   || '22:00');
  const [error,    setError]    = useState('');

  const toggleDia = (dia) => {
    setDiasActivos(prev =>
      prev.includes(dia)
        ? prev.filter(d => d !== dia)
        : [...prev, dia]
    );
    setError('');
  };

  const handleNext = () => {
    if (diasActivos.length === 0) {
      setError('Selecciona al menos un día de operación');
      return;
    }
    onNext({ diasActivos, apertura, cierre });
  };

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Horarios de operación</h2>
      <p style={styles.sub}>
        Define cuándo está disponible tu recinto. Los equipos
        solo verán horarios dentro de estos rangos.
      </p>

      {/* Días */}
      <div style={styles.campo}>
        <label style={styles.label}>Días disponibles</label>
        <div style={styles.diasGrid}>
          {DIAS.map(dia => {
            const activo = diasActivos.includes(dia);
            return (
              <div
                key={dia}
                onClick={() => toggleDia(dia)}
                style={{
                  ...styles.diaChip,
                  background: activo ? '#1A6BFF' : '#F4F6FA',
                  color:      activo ? 'white'   : '#4A5568',
                  border:     `1.5px solid ${activo ? '#1A6BFF' : '#E8ECF4'}`,
                }}
              >
                {dia.slice(0, 3)}
              </div>
            );
          })}
        </div>
        {error && <span style={styles.error}>{error}</span>}
      </div>

      {/* Horario */}
      <div style={styles.horarioRow}>
        <div style={{ flex: 1 }}>
          <label style={styles.label}>Hora de apertura</label>
          <select
            value={apertura}
            onChange={e => setApertura(e.target.value)}
            style={styles.select}
          >
            {HORAS_APERTURA.map(h => <option key={h}>{h}</option>)}
          </select>
        </div>
        <div style={styles.horarioSep}>—</div>
        <div style={{ flex: 1 }}>
          <label style={styles.label}>Hora de cierre</label>
          <select
            value={cierre}
            onChange={e => setCierre(e.target.value)}
            style={styles.select}
          >
            {HORAS_CIERRE.map(h => <option key={h}>{h}</option>)}
          </select>
        </div>
      </div>

      {/* Preview */}
      <div style={styles.preview}>
        <div style={styles.previewTitle}>Tu recinto estará disponible</div>
        <div style={styles.previewDias}>
          {diasActivos.length > 0
            ? diasActivos.join(' · ')
            : 'Ningún día seleccionado'}
        </div>
        <div style={styles.previewHoras}>
          {apertura} — {cierre}
        </div>
      </div>

      <div style={styles.botones}>
        <button style={styles.btnBack} onClick={onBack}>← Atrás</button>
        <button
          style={{
            ...styles.btnFinalizar,
            opacity: cargando ? 0.7 : 1,
          }}
          onClick={handleNext}
          disabled={cargando}
        >
          {cargando ? 'Registrando...' : '¡Registrar recinto! ⚡'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 24, lineHeight: 1.5,
  },
  campo: { marginBottom: 20 },
  label: {
    display: 'block', fontSize: 11, fontWeight: 700,
    color: '#6B7280', textTransform: 'uppercase',
    letterSpacing: '0.05em', marginBottom: 8,
    fontFamily: "'Barlow', sans-serif",
  },
  diasGrid: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  diaChip: {
    padding: '8px 14px', borderRadius: 20,
    fontSize: 12, fontWeight: 600,
    cursor: 'pointer', transition: 'all 0.12s',
    fontFamily: "'Barlow', sans-serif",
  },
  horarioRow: {
    display: 'flex', alignItems: 'flex-end',
    gap: 12, marginBottom: 20,
  },
  horarioSep: {
    fontSize: 18, color: '#9BA5B7',
    paddingBottom: 10,
  },
  select: {
    width: '100%', padding: '11px 14px',
    border: '1.5px solid #E8ECF4', borderRadius: 10,
    fontSize: 13, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', background: 'white',
    boxSizing: 'border-box',
  },
  preview: {
    background: '#F0FDF4',
    border: '1.5px solid #86EFAC',
    borderRadius: 12, padding: '14px 18px',
    marginBottom: 24, textAlign: 'center',
  },
  previewTitle: {
    fontSize: 11, fontWeight: 700, color: '#16A34A',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    fontFamily: "'Barlow', sans-serif", marginBottom: 6,
  },
  previewDias: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 700, color: '#16A34A', marginBottom: 4,
  },
  previewHoras: {
    fontSize: 14, color: '#16A34A',
    fontFamily: "'Barlow', sans-serif",
  },
  error: {
    display: 'block', fontSize: 11,
    color: '#EF4444', marginTop: 6,
    fontFamily: "'Barlow', sans-serif",
  },
  botones: {
    display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10,
  },
  btnBack: {
    padding: '13px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 12,
    fontSize: 14, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnFinalizar: {
    padding: '13px', background: '#FF6B1A',
    border: 'none', borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800,
    color: 'white', cursor: 'pointer',
  },
};